module.exports = __webpack_public_path__ + "img/EW-logo_green-black_horizontal.d1ad1938.png";